import { getDynamicData, loadScript, loadScriptOnUserInteraction } from '@avensia/excite';

async function loadTriggerbee(loadAfterTTI = true) {
  if (window.CookieInformation && !window.CookieInformation.getConsentGivenFor('cookie_cat_functional')) {
    return;
  }

  const scriptSettings = await getDynamicData<NordicNest.Api.ScriptSettingsApiModel>().current();
  if (scriptSettings && scriptSettings.triggerbeeSiteId && !__DEV__) {
    const scriptUrl =
      'https://t.myvisitors.se/js/' +
      scriptSettings.triggerbeeSiteId +
      (window.location.href.indexOf('tb-nocache') > -1 ? '?v=' + Math.floor(Math.random() * 999) : '');

    if (loadAfterTTI) {
      loadScriptOnUserInteraction('https://t.myvisitors.se/js?site_id=' + scriptSettings.triggerbeeSiteId);
      loadScriptOnUserInteraction(scriptUrl).catch(() => console.debug(`Can't load triggerbee script: ${scriptUrl}`));
    } else {
      loadScript('https://t.myvisitors.se/js?site_id=' + scriptSettings.triggerbeeSiteId);
      loadScript(scriptUrl).catch(() => console.debug(`Can't load triggerbee script: ${scriptUrl}`));
    }
  }
}

export async function useTriggerbee() {
  if (!__BROWSER__) {
    return;
  }

  loadTriggerbee();
  window.addEventListener('CookieInformationConsentGiven', function () {
    loadTriggerbee(false);
  });
}
